import React, { useEffect, useState, useRef } from 'react';

const pad2 = (n: number) => n.toString().padStart(2, '0');
interface HeaderProps {
  formattedDate: string;
}

const Clock: React.FC<HeaderProps> = ({ formattedDate }) => {
  const [now, setNow] = useState<Date | null>(null); // null -> evita mismatch SSR
  const timerRef = useRef<number | null>(null);
  const hiddenRef = useRef<boolean>(false);

  useEffect(() => {
    // inicializamos solo en cliente para evitar hydration mismatch
    setNow(new Date());

    const tick = () => {
      setNow(new Date());
      // alinear al siguiente segundo exacto:
      const msToNextSecond = 1000 - (Date.now() % 1000);
      timerRef.current = window.setTimeout(tick, msToNextSecond) as unknown as number;
    };

    // empezar alineado
    const msToNextSecond = 1000 - (Date.now() % 1000);
    timerRef.current = window.setTimeout(tick, msToNextSecond) as unknown as number;

    // Visibility API: pausar cuando la pestaña está oculta para ahorrar CPU
    const onVisibility = () => {
      hiddenRef.current = document.hidden;
      if (document.hidden) {
        if (timerRef.current != null) {
          clearTimeout(timerRef.current as unknown as number);
          timerRef.current = null;
        }
      } else {
        // reiniciar inmediatamente al volver
        setNow(new Date());
        const ms = 1000 - (Date.now() % 1000);
        timerRef.current = window.setTimeout(tick, ms) as unknown as number;
      }
    };
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      if (timerRef.current != null) clearTimeout(timerRef.current as unknown as number);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, []);

  if (!now) {
    // mientras el cliente inicializa, devolver placeholder (evita mismatch SSR)
    return (
      <div className="flex items-center space-x-2 bg-transparent" aria-hidden>
        <img src={'/assets/icons/alarm.png'} alt="" className="w-8 h-8 opacity-50" />
        <span className="text-3xl font-extrabold text-white font-mono">--:--:--</span>
      </div>
    );
  }

  // Opcional: usar Intl para formateo por locale
  const hh = pad2(now.getHours());
  const mm = pad2(now.getMinutes());
  const ss = pad2(now.getSeconds());

  return (
    <div className="flex items-center justify-center h-full pr-3">
      <img
        src={'/assets/icons/alarm.png'}
        alt="Alarma"
        className="w-12 h-12 opacity-50 mr-[-10px] "
      />
      <div className="flex flex-col items-end justify-end h-full mt-4 mb-4 space-y-[-8px]">
        <div className="flex items-center space-x-2 bg-transparent" role="timer" aria-live="polite">
          <time
            dateTime={now.toISOString()}
            className="tv-text-3xl font-extrabold text-white font-mono pl-4"
            style={{ fontVariantNumeric: 'tabular-nums' }}
            aria-label={`Current time ${hh}:${mm}:${ss}`}
          >
            {hh}:{mm}:{ss}
          </time>
        </div>
        <h1 className="tv-text-lg font-bold">WOD {formattedDate}</h1>
      </div>
    </div>
  );
};

export default React.memo(Clock);
